"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATE_CATEGORY_KEY = 'base';
exports.TRANSLATE_COMPONENT_KEY = 'translate';